import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  cover_image: string;
  category: string;
  categoryName: string;
  tags: string[];
  published_at: string;
  views: number;
  is_hot?: boolean;
  is_featured?: boolean;
}

export default function ArticleCard({ title, slug, excerpt, cover_image, category, categoryName, tags, published_at, views, is_hot, is_featured }: ArticleCardProps) {
  const dateStr = new Date(published_at).toLocaleDateString('zh-CN', {
    month: 'short',
    day: 'numeric',
  });

  const viewsStr = views > 10000 ? `${(views / 10000).toFixed(1)}万` : views.toString();

  return (
    <Link to={`/article/${slug}`} className="group block">
      <article className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 h-full flex flex-col">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={cover_image}
            alt={title}
            title={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          {(is_featured || is_hot) && (
            <div className="absolute top-3 left-3 flex gap-2">
              {is_featured && (
                <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-accent-500 text-foreground-950 whitespace-nowrap">
                  独家
                </span>
              )}
              {is_hot && (
                <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
                  热门
                </span>
              )}
            </div>
          )}
        </div>

        <div className="p-4 flex flex-col flex-1">
          <div className="flex items-center gap-2 mb-2.5">
            <Link
              to={`/category/${category}`}
              onClick={(e) => e.stopPropagation()}
              className="px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors whitespace-nowrap"
            >
              {categoryName}
            </Link>
            <span className="text-xs text-foreground-400">{dateStr}</span>
          </div>

          <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
            {title}
          </h3>

          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
            {excerpt}
          </p>

          <div className="flex items-center justify-between pt-3 border-t border-background-100">
            <div className="flex items-center gap-1.5 text-xs text-foreground-400">
              <i className="ri-eye-line"></i>
              <span>{viewsStr} 阅读</span>
            </div>
            <div className="flex items-center gap-1">
              {tags.slice(0, 2).map((tag) => (
                <Link
                  key={tag}
                  to={`/tag/${encodeURIComponent(tag)}`}
                  onClick={(e) => e.stopPropagation()}
                  className="text-xs text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  #{tag}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}
